import Icon, { IconProps } from './Icon';

export type { IconProps };
export default Icon;
